import { Node, mergeAttributes } from "@tiptap/core"
import { VueNodeViewRenderer } from "@tiptap/vue-3"
import ListingsBlockComponent from "./ListingsBlockComponent.vue"

export interface ListingsBlockOptions {
    HTMLAttributes: Record<string, any>
}

declare module "@tiptap/core" {
    interface Commands<ReturnType> {
        listingsBlock: {
            /**
             * Insert a listings block
             */
            insertListingsBlock: (listings: any[]) => ReturnType
        }
    }
}

export default Node.create<ListingsBlockOptions>({
    name: "listingsBlock",

    group: "block",

    atom: true,

    addOptions() {
        return {
            HTMLAttributes: {},
        }
    },

    addAttributes() {
        return {
            listings: {
                default: [],
                parseHTML: (element) => {
                    const listingsData = element.getAttribute("data-listings")
                    return listingsData ? JSON.parse(listingsData) : []
                },
                renderHTML: (attributes) => {
                    return {
                        "data-listings": JSON.stringify(attributes.listings),
                    }
                },
            },
        }
    },

    parseHTML() {
        return [
            {
                tag: 'div[data-type="listings-block"]',
            },
        ]
    },

    renderHTML({ HTMLAttributes }) {
        return ["div", mergeAttributes(HTMLAttributes, { "data-type": "listings-block" })]
    },

    addNodeView() {
        return VueNodeViewRenderer(ListingsBlockComponent)
    },

    addCommands() {
        return {
            insertListingsBlock:
                (listings: any[]) =>
                ({ commands }) => {
                    return commands.insertContent({
                        type: this.name,
                        attrs: {
                            listings,
                        },
                    })
                },
        }
    },
})
